var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdobeAnalyticsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Brush",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240 235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 97.71,
    cy: 81.62,
    r: 143.79,
    gradientTransform: "translate(-10.91 -10.93) scale(1.09 1.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e234a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#130732"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1 copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 235,
    fill: "url(#radial-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97,118H87.5v62.43a77.64,77.64,0,0,0,9.5,3.78Zm17.5-4v73.56c1.33.07,3.29.75,4.64.75,1.68,0,3.21,0,4.86-.14V114ZM169,166.22a78.23,78.23,0,0,0,9.5-12.08V106.5H169ZM64.94,122,86.87,96.69l20.84,7.75,44.46-31.89,22.41,21.21,11.26-9L184.11,81l-9.41,7.94L152.61,68.31l-45.16,32.32-21-8.14L63.13,118.9,48.5,122.34v3.38Zm4.56,15H60v18.43a75.59,75.59,0,0,0,9.5,11.2Zm82-42H142v88.88a78.19,78.19,0,0,0,9.5-4Z",
    fill: "#e2d8ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75,117A103.25,103.25,0,1,0,120,13.75,103.25,103.25,0,0,0,16.75,117Zm10.65,0A92.61,92.61,0,1,1,120,209.72,92.66,92.66,0,0,1,27.39,117Z",
    fill: "#9f7fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobeAnalyticsLogo);
export default __webpack_public_path__ + "static/media/adobe-analytics-logo.4303b1eeeaf14bcbe9c12447b1c08ec9.svg";
export { ForwardRef as ReactComponent };